import { SelectedTime } from '@lyearn/ui';
import { parseFormDataFunction } from '@/modules/corporate/modules/database/fields/types';

const parseFormData: parseFormDataFunction = (data: { startTime?: SelectedTime }, field) => ({
  value: data.startTime?.toISOString() || '',
  metadata: {
    d: {
      startDate: data.startTime?.toISOString() || '',
      timeFormat: field.metadataField.dateFormat,
    },
  },
});

export default parseFormData;
